<template>
<div class="data-list-container rearrange_holder">
 <div
    :class="
      !$route.params.module_name
        ? 'vs-component con-vs-popup vs-popup-primary cstm-modal-popup show'
        : ''
    "
  >
   <div class="cstm-modal medium fixed_medium">
     <div class="header" v-if="!$route.params.module_name">
      <h4>{{ moduleName }} Field Rearrange</h4>
          <button @click.stop="closePopup" class="close-modal">&times;</button>
        </div>
       <div
            style="max-height: calc(100vh - 200px); overflow-y: auto"
            class="table_responsive vertical_scrollbar"
          >
      <div slot="media" class="p-3">
        <div slot="media" class="p-3">
          <vs-row vs-w="12">
            <vs-col vs-w="12" class="m-4">
              <vs-button class="block ml-auto" @click="displayFieldColumn">Submit</vs-button>
            </vs-col>

            <vs-col vs-w="6">
              <vs-list class="list-holder">
                <vs-list-header title="System Fields" />
                <draggable
                  :list="allSystemField"
                  group="status"
                  class="p-2 cursor-move drop-zone staticField"
                  style="min-height: 30vh"
                  :move="checkDisplayFieldMove"
                >
                  <transition-group>
                    <div class="arrange_drag_card" v-for="(field, index) in allSystemField" :key="index">
                      <span class="material-icons-outlined drag_icon">drag_indicator</span>
                      <vx-card
                        v-if="checkForHiddenField(moduleName, field)"
                        class="list-item"                       
                        :title="field.field_label"
                      >
                      <!-- <span class="span">{{field.field_type}}</span> -->
                        <vs-row vs-type="flex" vs-justify="flex-end">
                          <!--  <vs-button radius @click="handleStatusEdit(status_list)" icon="edit" color="primary" class="mr-2" v-if="status_list.status_name !== 'New' "/>
                          <vs-button radius @click="handleStatusDelete(status_list)"  icon="delete" color="danger" v-if="status_list.status_name !== 'New' "/> -->
                        </vs-row>
                        <!-- <vs-chip color="danger" closable @click="handleRemoveStatusList(status_list.status_id)" style="float:left;"> {{ status_list.status_name }} </vs-chip> -->
                      </vx-card>
                    </div>
                  </transition-group>
                </draggable>
                <vs-list-header title="Dynamic Fields"  v-if="is_dynamic"/>
                <!-- <pre>{{ allDynamicField }}</pre> -->
                <draggable
                  :list="allDynamicField"
                  group="status"
                  class="p-2 cursor-move drop-zone dynamicField"
                  style="min-height: 30vh"
                  :move="checkDisplayFieldMove"
                >
                  <transition-group>
                    <div class="arrange_drag_card" v-for="(field, index) in allDynamicField"
                      :key="index">
                      <span class="material-icons-outlined drag_icon">drag_indicator</span>
                      <vx-card
                        class="list-item"
                        :title="field.field_label"
                      >
                      <!-- <span class="span">{{field.field_type}}</span> -->
                        <vs-row vs-type="flex" vs-justify="flex-end">
                          <!--  <vs-button radius @click="handleStatusEdit(status_list)" icon="edit" color="primary" class="mr-2" v-if="status_list.status_name !== 'New' "/>
                          <vs-button radius @click="handleStatusDelete(status_list)"  icon="delete" color="danger" v-if="status_list.status_name !== 'New' "/> -->
                        </vs-row>
                        <!-- <vs-chip color="danger" closable @click="handleRemoveStatusList(status_list.status_id)" style="float:left;"> {{ status_list.status_name }} </vs-chip> -->
                      </vx-card>
                    </div>
                  </transition-group>
                </draggable>
              </vs-list>
            </vs-col>
            <vs-col vs-w="6">
              <vs-list class="list-holder">
                <vs-list-header title="Visible Fields" />
                <draggable
                  :list="displayField"
                  :move="checkDisplayFieldMove"
                  group="status"
                  class="p-2 cursor-move"
                  style="min-height: 30vh"
                >
                  <transition-group>
                    <div class="arrange_drag_card" v-for="(field, index) in displayField"
                      :key="index">
                      <span class="material-icons-outlined drag_icon">drag_indicator</span>
                      <vx-card
                        class="list-item"
                        :title="field.field_label === 'First Name' ? 'Full Name' : field.field_label"
                      >
                      <span class="span_holder">{{field.field_type}} Field</span>
                        <vs-row vs-type="flex" vs-justify="flex-end">
                          <!--  <vs-button radius @click="handleStatusEdit(status_list)" icon="edit" color="primary" class="mr-2" v-if="status_list.status_name !== 'New' "/>
                          <vs-button radius @click="handleStatusDelete(status_list)"  icon="delete" color="danger" v-if="status_list.status_name !== 'New' "/> -->
                        </vs-row>
                        <!-- <vs-chip color="danger" closable @click="handleRemoveStatusList(status_list.status_id)" style="float:left;"> {{ status_list.status_name }} </vs-chip> -->
                      </vx-card>
                    </div>
                  </transition-group>
                </draggable>
              </vs-list>
              
            </vs-col>
          </vs-row>
        </div>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { fetchField, arrangeColumn } from '@/api/columnrearrange'
import { fetchCustomFieldsV2 } from '@/api/customfield'
export default {
  name: 'fieldrearrange',
  components: {
    draggable
  },
  data () {
    return {
      allSystemField: [],
      displayField: [],
      allDynamicField: [],
      recentDraggableLableName: '',
      moduleName:''
    }
  },
  props:{
    moduleProps:{},
    modelnamePass: {
      default: ''
    },
    type: {
      default: ''
    },
    table_name: {
      default: ''
    },
    is_dynamic:{
      default: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('closeRearrangementModal', true)
    },
    checkForHiddenField (moduleName, field) {
      switch(moduleName) {
        case 'CRM':
          if (field.field_name !== 'lead_middle_name' && field.field_name !== 'lead_last_name') 
            return true
          break;
        case 'Students':
          if (field.field_name !== 'middle_name' && field.field_name !== 'last_name' && field.field_name !== 'platform_timezone_id')
            return true
          break;
        case 'Staff':
          if (field.field_name !== 'middle_name' && field.field_name !== 'last_name')
            return true
          break;
        default:
          return false
      }
      return false
    },
    handleRedirect () {
      this.$router.push({
        name: 'custom-value-list-view',
        params: { modelname: this.$route.params.module_name ? this.$route.params.module_name : this.modelnamePass}
      })
    },
    fetchAllSystemField () {

      const fetchSystemFieldRequestParameter = {
        type: this.moduleName,
        fetch_status: 'system',
        customer_id: this.$store.getters.customerId,
        table_name:this.table_name
      }
      fetchField(fetchSystemFieldRequestParameter)
        .then((apiResponse) => {
          this.allSystemField = apiResponse.data.data.results
        })
        .catch((apiError) => {
          console.warn(apiError)
        })
    },
    async fetchDisplayField () {

      try {

        // let module_name = this.moduleName === 'Client' ? 'Students' : this.moduleName
        const fetchDisplayFieldRequestParameter = {
          type: this.moduleName,
          fetch_status: 'display',
          customer_id: this.$store.getters.customerId,
          table_name:this.table_name
        }
        console.log(fetchDisplayFieldRequestParameter)
        const apiResponse = await fetchField(fetchDisplayFieldRequestParameter)
        this.displayField = apiResponse.data.data.results

      } catch (apiError) {
        console.warn(apiError)
        
      }
    },
    async fetchDynamicField () {
      try {
        const apiResponse = await fetchCustomFieldsV2(this.moduleName, this.$store.getters.customerId)
        this.allDynamicField = apiResponse.data.data.custom_fields
      } catch (apiError) {
        console.warn(apiError)

      }
    },
    checkDisplayFieldMove (event) {
      if (this.moduleName === 'CRM') {
        const classArray =
          event.relatedContext.component.$el.classList.value.split(' ')
        console.log(classArray)
        if (classArray.includes('staticField') === true) {
          if (
            event.draggedContext.element.field_label === 'First Name' ||
            event.draggedContext.element.field_label === 'Status' ||
            event.draggedContext.element.field_type === 'dynamic'
          ) {
            return false
          } else {
            return true
          }
        } else if (event.draggedContext.element.field_type === 'system' && classArray.includes('dynamicField') === true) {
          return false
        } else {
          return true
        }
      } else {
        const classArray =
          event.relatedContext.component.$el.classList.value.split(' ')
        if (classArray.includes('staticField') === true) {
          if (event.draggedContext.element.field_label === 'First Name' || event.draggedContext.element.field_type === 'dynamic') {
            return false
          } else {
            return true
          }
        } else if (event.draggedContext.element.field_type === 'system' && classArray.includes('dynamicField') === true) {
          return false
        } else {
          return true
        }
      }
    },
    displayFieldColumn () {
      console.log('Display Field') 
      const rearrangeColumn = this.displayField
      rearrangeColumn.map((item, index) => {
        item.order = `${index + 1}`
      })
      const arrangeColumnRequestParameter = {
        type: this.moduleName,
        from_list: '0',
        fields_display_order: rearrangeColumn,
        customer_id: this.$store.getters.customerId,
        table_name:this.table_name
      }
      arrangeColumn(arrangeColumnRequestParameter)
        .then((apiResponse) => {
          this.$emit('closeRearrangementModal', true)
          this.$vs.notify({
            title: 'Success',
            text: `${apiResponse.data.message}`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          const module_name = this.$route.params.module_name
            ? this.$route.params.module_name
            : this.modelnamePass

          const ManagementType = this.$route.params.type ? this.$route.params.type : this.type
          if (ManagementType === 'settings') {
            this.$router.push({name:'v1-settings'})
          } else if (module_name === 'Leads') {
            this.$router.push('/pages/leads')
          } else if (module_name === 'Students') {
            this.$router.push('/clients')
          } else if (module_name === 'Staff' || ManagementType === 'Staff') {
            this.$router.push('/staff')
          }  
          this.closePopup()  
        })
        .catch((apiError) => {
          console.warn(apiError)
        })
    }
  },
  mounted () {
    if (this.$route.params.module_name) {
      this.table_name = this.$route.params.table_name
      this.is_dynamic = ['Leads', 'Students', 'Staff'].includes(this.$route.params.module_name)
      this.moduleName =  this.$route.params.module_name.charAt(0).toUpperCase() +
        this.$route.params.module_name.slice(1)
    } else {
      this.moduleName =  this.modelnamePass
    }
    if (this.moduleProps) {
      this.moduleName = this.moduleProps

    }
    if (this.moduleName === 'Leads') {
      this.moduleName = 'CRM'
    }
    this.fetchAllSystemField()
    this.fetchDisplayField()
    this.fetchDynamicField()
    
  },
  watch: {
    
  }
}
</script>
<style>
.list-holder .list-item:not(:last-child),
.list-holder .active-list:not(:last-child) {
  margin-bottom: 10px;
}
.rearrange_holder .list-holder .vx-card {
  min-height: 100%;
}
.list-holder .vx-card {
  min-height: 80px;
}
.list-holder .vs-list--header {
  font-size: 18px;
  padding-left: 10px;
}
.list-holder .list-item {
  transition: all 1s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-item .vx-card__header {
  padding: 0 1.5rem 0 0 !important;
}
.active-list {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  min-height: 80px;
  padding: 0 1.5rem;
}
</style>

